import React, { useState } from 'react';
import { useApp } from '../contexts/AppContext';

// Inline fallback — dipakai jika file SVG di public/ gagal di-load.
// Theme-aware tone biru sesuai brand KES (network nodes icon).
const KesFallbackIcon = ({ theme, size = 22 }) => {
  const outer  = theme === 'dark' ? '#3b82f6' : '#1e3a8a';
  const inner  = theme === 'dark' ? '#60a5fa' : '#3b82f6';
  const center = theme === 'dark' ? '#93c5fd' : '#60a5fa';
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0, opacity: 1 }}>
      <line x1="10" y1="10" x2="10" y2="2"    stroke={outer} strokeWidth="1.3"/>
      <line x1="10" y1="10" x2="10" y2="18"   stroke={outer} strokeWidth="1.3"/>
      <line x1="10" y1="10" x2="2"  y2="10"   stroke={outer} strokeWidth="1.3"/>
      <line x1="10" y1="10" x2="18" y2="10"   stroke={outer} strokeWidth="1.3"/>
      <line x1="10" y1="10" x2="3.5"  y2="3.5"  stroke={outer} strokeWidth="1.3"/>
      <line x1="10" y1="10" x2="16.5" y2="3.5"  stroke={outer} strokeWidth="1.3"/>
      <line x1="10" y1="10" x2="3.5"  y2="16.5" stroke={outer} strokeWidth="1.3"/>
      <line x1="10" y1="10" x2="16.5" y2="16.5" stroke={outer} strokeWidth="1.3"/>
      <line x1="10" y1="10" x2="6.2"  y2="6.2"  stroke={inner} strokeWidth="1.5"/>
      <line x1="10" y1="10" x2="13.8" y2="6.2"  stroke={inner} strokeWidth="1.5"/>
      <line x1="10" y1="10" x2="6.2"  y2="13.8" stroke={inner} strokeWidth="1.5"/>
      <line x1="10" y1="10" x2="13.8" y2="13.8" stroke={inner} strokeWidth="1.5"/>
      <circle cx="10"  cy="2"    r="1.7" fill={outer}/>
      <circle cx="10"  cy="18"   r="1.7" fill={outer}/>
      <circle cx="2"   cy="10"   r="1.7" fill={outer}/>
      <circle cx="18"  cy="10"   r="1.7" fill={outer}/>
      <circle cx="3.5"  cy="3.5"  r="1.7" fill={outer}/>
      <circle cx="16.5" cy="3.5"  r="1.7" fill={outer}/>
      <circle cx="3.5"  cy="16.5" r="1.7" fill={outer}/>
      <circle cx="16.5" cy="16.5" r="1.7" fill={outer}/>
      <circle cx="6.2"  cy="6.2"  r="1.8" fill={inner}/>
      <circle cx="13.8" cy="6.2"  r="1.8" fill={inner}/>
      <circle cx="6.2"  cy="13.8" r="1.8" fill={inner}/>
      <circle cx="13.8" cy="13.8" r="1.8" fill={inner}/>
      <circle cx="10"   cy="10"   r="2.4" fill={center}/>
    </svg>
  );
};

const Footer = () => {
  const { theme } = useApp();
  const [imgFailed, setImgFailed] = useState(false);

  // KES ICON BG DARK = icon untuk dipakai DI ATAS background dark → graphic terang
  // KES ICON BG WHITE = icon untuk dipakai DI ATAS background light → graphic gelap
  const logoSrc = `/kes-icon-${theme === 'dark' ? 'dark' : 'light'}.svg`;

  return (
    <footer
      style={{
        borderTop: '1px solid var(--border-dim)',
        padding: '14px 24px',
        background: 'var(--color-surface)',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        flexWrap: 'wrap',
      }}
    >
      <span
        style={{
          fontFamily: '"IBM Plex Mono", monospace',
          fontSize: 13,
          fontWeight: 500,
          color: 'var(--text-mid)',
          letterSpacing: '0.02em',
        }}
      >
        © 2026
      </span>
      {imgFailed ? (
        <KesFallbackIcon theme={theme} size={22} />
      ) : (
        <img
          src={logoSrc}
          alt="KES"
          width={22}
          height={22}
          style={{ flexShrink: 0, objectFit: 'contain', opacity: 1, verticalAlign: 'middle' }}
          onError={() => setImgFailed(true)}
        />
      )}
      <span
        style={{
          fontFamily: '"IBM Plex Mono", monospace',
          fontSize: 13,
          fontWeight: 500,
          color: 'var(--text-mid)',
          letterSpacing: '0.02em',
        }}
      >
        KES (PT Kartika Eka Satria). All rights reserved.
      </span>
    </footer>
  );
};

export default Footer;
